// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Montserrat from '../_raw/flag/icon_flag_montserrat.png';

export default () => <img src={Montserrat} alt="Montserrat" />;
